import { FormEvent, useEffect, useState } from "react";
import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import { auth } from "../lib/firebase";

function readActionParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    mode: params.get("mode"),
    oobCode: params.get("oobCode"),
  };
}

export function PasswordActionPage() {
  const [{ mode, oobCode }] = useState(readActionParams);
  const [email, setEmail] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!auth || mode !== "resetPassword" || !oobCode) {
      setError("Lien de réinitialisation invalide.");
      return;
    }

    void verifyPasswordResetCode(auth, oobCode)
      .then(setEmail)
      .catch((verifyError: unknown) => {
        console.error(verifyError);
        setError("Ce lien de réinitialisation est invalide ou expiré.");
      });
  }, [mode, oobCode]);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (!auth || !oobCode) {
      setError("Lien de réinitialisation invalide.");
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setSuccess(true);
      window.history.replaceState({}, "", window.location.pathname);
    } catch (resetError) {
      console.error(resetError);
      setError(
        resetError instanceof Error
          ? resetError.message
          : "Impossible d'enregistrer ce nouveau mot de passe.",
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="auth-shell">
      <section className="auth-panel" aria-labelledby="reset-title">
        <p className="eyebrow">Sécurité</p>
        <h1 id="reset-title">Nouveau mot de passe</h1>

        {email ? <p className="lead">{email}</p> : null}

        {error ? (
          <div className="alert alert-error" role="alert">
            {error}
          </div>
        ) : null}

        {success ? (
          <div className="alert alert-success" role="status">
            Mot de passe mis à jour. Vous pouvez vous connecter.
          </div>
        ) : (
          <form className="stack" onSubmit={handleSubmit}>
            <label className="field">
              <span>Nouveau mot de passe</span>
              <input
                autoComplete="new-password"
                minLength={8}
                onChange={(event) => setPassword(event.target.value)}
                required
                type="password"
                value={password}
              />
            </label>
            <button
              className="button button-primary"
              disabled={isSubmitting || !email}
              type="submit"
            >
              {isSubmitting ? "Enregistrement..." : "Enregistrer"}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
